import { getEntrata } from './entrata/entrata-data.js';
// import { unitFilters } from './entrata/unit-filters';
import * as FPUI from './entrata/floor-plan-ui.js';
/**
 * 
 *    Entrata API logic for the front end
 *    
 *    NOTE: 
 *      The website only shows what I call "root" Floor Plans (A1, B2, etc...) 
 *      Edge Case-- The "root" Floor Plan might also be A1S, or B2S if the floor plan has a sunroom, you can't rely on the first 2 characters only
 *      In Entrata there's actually a separate floor plan for every finish level (A1-r, A1-u, etc...)
 *      There might also be a floor plan without any finish level identifier which is their standard floor plan that has never been updated or renovated
 *      so there might be A1, A1-r, A1-u, etc...
 *      They don't always have a hyphen between the root and the finish level. Many are named A1U, B2R, etc...
 *      as of 7-14-21 they also have floor plans labeled with "Townhome" at the end like
 *      "B2 Townhome" and "B2R Townhome"
 * 
 */

(function($) {
  $(document).ready(async function() {
    try {
      
      // fetch floor plan availability and pricing data 
      const entrataData = await getEntrata();
      
      // const $unitFilters = unitFilters({
      //   availableFloorPlans: entrataData.available_floor_plans,
      //   availableUnits: entrataData.available_units,
      //   build: FPUI.updateUnitSections,
      //   $attachPoint: $('.filters')
      // });
      
      // reveal leasing specific content 
      // TODO: remove this from the theme level and only have this content patched in via this plugin
      $('.floor-plans-list').removeClass('api-disabled');

      // add attributes and UI components to each floor plan card
      FPUI.initFpCards($('.fp-card'), entrataData);

      // Attach Click handler to buttons for each floor plan finish level to reveal their available units
      // $('.sub-plan-buttons-section').on('click', 'button', FPUI.drawerToggleButtonControl);
      
    } catch(e) {
      // $('.floor-plans-list').addClass('api-disabled');
      console.log('ERROR:', e);
    }
  });
})(jQuery);